export default __webpack_public_path__ + "static/media/Default.186c3f92.mp4";